export default {
  posts: [],
  important_posts: [],
  selectedPost: null,
  error: false,
  errorMessage: '',
  lastMomentSecurity: null,
  lastPosts: [],
}